import "../assets/css/vendor-product-forms.css";
import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Alert,
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
} from "react-bootstrap";
import DiscountFields, { discountPayloadOf } from "../components/DiscountFields";
import { useProductFormGate } from "../components/team/Gated";
import HeadOfficeProductNote from "../components/branch/HeadOfficeProductNote";
import {
  MdWarning,
  MdCrop,
  MdCropSquare,
  MdCropLandscape,
} from "react-icons/md";
import { Switch, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { uploadImageToCloudinary as sharedUpload } from "../utilities/imageUpload";
import { toast } from "react-toastify";
import Select from "../components/ui/AppReactSelect";
import { AppAsyncSelect as AsyncSelect } from "../components/ui/AppReactSelect";
import CategorySuggestions from "../components/catalog/CategorySuggestions";
import { categoryPickerOptions, unitSelectOptions } from "../utilities/catalogTaxonomy";
import {
  fetchRetailerWholesalerSections,
  fetchRetailerWholesalers,
} from "../actions/retailerWholesalerSectionActions";
import { fetchRetailerWholesalerOptionGroups } from "../actions/retailerWholesalerOptionActions";
// import OptionGroupForm from './OptionsGroupForm';
import { createRetailerWholesalerProduct } from "../actions/retailerWholesalerProductActions";
import { getUserFromLocalStorage } from "../utilities/user.js";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  DESCRIPTION_QUILL_MODULES,
  DESCRIPTION_QUILL_FORMATS,
  DESCRIPTION_EDITOR_CLASS,
  DESCRIPTION_TYPOGRAPHY_CSS,
  quillHtmlToPlainText,
} from "../utilities/richText";
import RetailerWholesalerOptionGroupForm from "./RetailerWholesalerOptionGroupForm";
import { getSiUnits } from "actions/siUnitActions";
import ReactCrop from "react-image-crop";
import { centerCrop, makeAspectCrop } from "react-image-crop";
import { IconButton, Tooltip } from "@material-ui/core";
import ProductImageSection from "../components/ProductImageSection";
import ProductFreightFields, {
  emptyProductFulfillment,
  serialiseProductFulfillment,
} from "../components/ProductFreightFields";
import ProductVideoSection from "../components/ProductVideoSection";
import UploadProgress from "../components/UploadProgress";
import AppSelect from "../components/ui/AppSelect";
import { vendorOwnerIdOf } from "../utilities/vendorScope";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "normal",
    fontSize: "12px",
    textTransform: "capitalize",
  },
}));

const adornedStyles = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.create-product-card-adorned {
  animation: fadeIn 0.5s ease-out;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.create-product-header-adorned {
  background: linear-gradient(135deg, #005370 0%, #0291a1ff 100%) !important;
  color: white !important;
  padding: 32px !important;
  border: none !important;
  border-radius: 16px 16px 0 0 !important;
}

.create-product-body-adorned {
  padding: 32px !important;
  background: white;
}

.form-section-adorned {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.form-section-adorned:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.form-label-adorned {
  font-weight: 600 !important;
  color: #005370 !important;
  font-size: 14px !important;
  margin-bottom: 8px !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-adorned {
  border: 2px solid #e9ecef !important;
  border-radius: 8px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-adorned:focus {
  border-color: #005370 !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 83, 112, 0.15) !important;
}

.btn-adorned-primary {
  background: #005370 !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
  box-shadow: 0 4px 12px rgba(0, 83, 112, 0.3) !important;
}

.btn-adorned-primary:hover {
  background: #0291a1ff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 83, 112, 0.4) !important;
}

.btn-adorned-secondary {
  background: #6c757d !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.btn-adorned-secondary:hover {
  background: #5a6268 !important;
  transform: translateY(-2px);
}

.btn-adorned-success {
  background: #28a745 !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.btn-adorned-success:hover {
  background: #218838 !important;
  transform: translateY(-2px);
}

.image-upload-card-adorned {
  border: 2px dashed #005370 !important;
  border-radius: 12px !important;
  background: #f8f9fa !important;
  transition: all 0.3s ease !important;
}

.image-upload-card-adorned:hover {
  border-color: #0291a1ff !important;
  background: #e9ecef !important;
}

.modal-adorned .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

.modal-adorned .modal-header {
  background: linear-gradient(135deg, #005370 0%, #0291a1ff 100%) !important;
  color: white !important;
  border-radius: 16px 16px 0 0 !important;
  padding: 24px !important;
  border: none !important;
}

.modal-adorned .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modal-adorned .modal-title {
  font-weight: 700 !important;
  font-family: 'Inter', sans-serif !important;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`;

const CreateRetailerWholesalerProductForm = () => {
  const user = getUserFromLocalStorage();
  const vendorId = vendorOwnerIdOf(user);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const sections = useSelector(
    (state) => state.retailerWholesalerSections.sectionsRW
  );
  const retailersWholesalers = useSelector(
    (state) => state.retailerWholesalerSections.retailersWholesalers
  );
  const optionGroups = useSelector(
    (state) => state.retailerWholesalerOptions.optionGroups
  );

  const { siUnits, loading } = useSelector((state) => state.siUnits);

  const isMounted = useRef(true);

  useEffect(() => {
    dispatch(fetchRetailerWholesalerSections(vendorId));
    dispatch(fetchRetailerWholesalers(vendorId));
    dispatch(fetchRetailerWholesalerOptionGroups(vendorId));

    return () => {
      isMounted.current = false;
    };
  }, [dispatch]);

  //   Get Units
  useEffect(() => {
    dispatch(getSiUnits());
  }, []);

  /* The unit picker reads `siUnits` directly through unitSelectOptions(),
     which groups by family and leaves plural duplicates out. */

  const initialSection = location.state?.sectionId || "";

  const [product, setProduct] = useState({
    name: "",
    description: "",
    section: initialSection,
    retailerWholesaler: "",
    price: 0.0,
    countInStock: 0,
    image: null,
    /* Optional extra angles — see AdditionalImagesStrip for details. */
    additionalImages: [],
    /* Product videos — frozen contract entries, see ProductVideoSection. */
    videos: [],
    // Deactivated until QC activates it (see the model default).
    enabled: false,
    optionGroups: [],
    measurements: 1,
    codDisabled: false,
    requiredPaymentMethod: "NONE",
    /* Packed shipping facts (weight, carton size, vehicle). The delivery
       engine resolves the vehicle class from these at checkout; wholesale
       listings must carry a packed weight (server rule). */
    fulfillment: emptyProductFulfillment(),
    discount: null,
  });

  const [priceWarning, setPriceWarning] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState(null);
  const [isFormatCorrect, setIsFormatCorrect] = useState(false);
  const [isSizeCorrect, setIsSizeCorrect] = useState(false);
  const [isResolutionCorrect, setIsResolutionCorrect] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const gate = useProductFormGate(submitting || uploading);

  const [selectedUnit, setSelectedUnit] = useState([]);

  const [selectedOptionGroups, setSelectedOptionGroups] = useState([]);
  const [showOptionGroupModal, setShowOptionGroupModal] = useState(false);

  const [minimumOrderVolume, setMinimumOrderVolume] = useState(10);
  const [operationMode, setOperationMode] = useState("");

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [inputValue, setValue] = useState("");

  const [currentImage, setCurrentImage] = useState(null);
  const previewCanvasRef = useRef(null);

  const [aspect, setAspect] = useState(1);
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);

  const ASPECT_RATIO = 1; // For 1:1 square crop
  const MIN_DIMENSION = 1000; // Minimum dimension requirement
  // PREVIEW_CONTAINER_SIZE removed with the old inline preview card — the
  // shared ProductImageSection sizes its own drop target.

  useEffect(() => {
    if (retailersWholesalers.length > 0) {
      setOperationMode(retailersWholesalers[0].operationMode);
    }
  }, [retailersWholesalers]);

  // Category Select
  // Every category, kept for the suggestions to resolve their picks against.
  const [allCategories, setAllCategories] = useState([]);
  const loadCategory = useCallback(async (inputValue) => {
    const res = await fetch("/category/get-all");
    const categories = await res.json();
    if (Array.isArray(categories)) setAllCategories(categories);
    // Grouped, "All"/"Random"/inactive left out, aliases and keywords searchable.
    return categoryPickerOptions(Array.isArray(categories) ? categories : [], {
      input: inputValue,
      selected: selectedCategory,
    });
  }, [selectedCategory]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "price") {
      if (parseFloat(value) < 0) {
        setPriceWarning("Please enter a Price higher than 0.");
        setProduct((prev) => ({ ...prev, [name]: "" }));
        return;
      } else {
        setPriceWarning("");
      }
    }

    if (name === "countInStock" && value < 1) {
      toast.error("Count in Stock cannot be less than 1");
      return;
    }

    setProduct({ ...product, [name]: value });
  };

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
          height: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }

  const handleImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    let initialCrop;

    if (aspect) {
      initialCrop = centerAspectCrop(width, height, aspect);
    } else {
      // For free crop, just use default values
      initialCrop = {
        unit: "%",
        x: 10,
        y: 10,
        width: 80,
        height: 80,
      };
    }

    setCrop(initialCrop);
    setCompletedCrop(initialCrop);
  };

  useEffect(() => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      imgRef.current &&
      previewCanvasRef.current
    ) {
      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;

      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext("2d");

      const pixelRatio = window.devicePixelRatio;

      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;

      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
    }
  }, [completedCrop]);

  const handleSaveCrop = useCallback(async () => {
    if (!imgRef.current || !completedCrop) return;

    const canvas = document.createElement("canvas");
    const image = imgRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    // Convert canvas to base64 string for preview
    const base64Image = canvas.toDataURL("image/jpeg", 1.0);

    // Also store the blob for later upload
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        setProduct((prev) => ({
          ...prev,
          image: blob, // Store the blob for later upload
        }));
        setImagePreview(base64Image); // Use base64 for preview
        setShowPreviewModal(false);
        setIsResolutionCorrect(true);
      },
      "image/jpeg",
      1
    );
  }, [completedCrop]);

  // Takes a File rather than a change event: the image section now accepts
  // drag-and-drop, and a drop has no <input> to read `target.files` from.
  const handleImageFile = (file) => {
    if (!file) {
      setUploadError("No file was selected.");
      toast.error("No file was selected.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setCrop({
        unit: "%",
        x: 0,
        y: 0,
        width: 90,
        height: 90,
      });
      setCompletedCrop(null);

      const img = new Image();
      img.onload = () => {
        if (!isMounted.current) return;

        const validFormats = ["image/jpeg", "image/png"];
        const isCurrentFormatCorrect = validFormats.includes(file.type);
        const isCurrentSizeCorrect = file.size <= 10 * 1024 * 1024;
        // The 1000x1000 minimum used to be enforced by an <img onLoad> on the
        // preview, which painted a red "Dimensions ✘" bar over the thumbnail.
        // That preview markup now lives in the shared ProductImageSection, so
        // the check moves here alongside format and size — one place, one error
        // channel, and it matches how the Edit form has always done it.
        const isCurrentResolutionCorrect =
          img.width >= MIN_DIMENSION && img.height >= MIN_DIMENSION;

        setIsFormatCorrect(isCurrentFormatCorrect);
        setIsSizeCorrect(isCurrentSizeCorrect);
        setIsResolutionCorrect(isCurrentResolutionCorrect);
        setImagePreview(reader.result);
        setShowPreviewModal(true);

        if (
          !isCurrentFormatCorrect ||
          !isCurrentSizeCorrect ||
          !isCurrentResolutionCorrect
        ) {
          let errorMessage =
            "Please ensure the image meets all the requirements:";
          if (!isCurrentFormatCorrect)
            errorMessage += " Must be JPG or PNG format.";
          if (!isCurrentSizeCorrect)
            errorMessage += " Must be less than or equal to 10MB.";
          if (!isCurrentResolutionCorrect)
            errorMessage += ` Must be at least ${MIN_DIMENSION}x${MIN_DIMENSION} pixels.`;
          setUploadError(errorMessage);
        } else {
          setUploadError(null);
        }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToCloudinary = async (file, assetPurpose = "product_cover") => {
    if (!file) {
      toast.error("No image file selected!");
      return null;
    }

    setUploading(true);
    try {
      const result = await sharedUpload(file, {
        skipValidation: true,
        vendorMedia: {
          vendorType: "retailer_wholesaler",
          vendorId: product.retailerWholesaler || vendorId,
          assetPurpose,
          entityType: "retailerWholesalerProduct",
          entityId: product._id || product.name || "new-product",
          source: "dashboard",
        },
        onProgress: (percent) => {
          if (!isMounted.current) return;
          setUploadProgress(percent);
        },
      });
      const secureUrl = result.secure_url;
      if (!isMounted.current) return null;

      setProduct((prevProduct) => ({
        ...prevProduct,
        image: secureUrl,
      }));
      setUploading(false);
      setShowPreviewModal(false);
      return secureUrl;
    } catch (error) {
      if (!isMounted.current) return null;

      console.error("Error uploading the image:", error);
      toast.error(`Failed to upload image: ${error.message}`);
      setUploading(false);
      setShowPreviewModal(false);
      return null;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setUploading(true);

    try {
      // First upload image to Cloudinary if it exists and is a Blob
      let imageUrl = product.image;
      if (product.image instanceof Blob) {
        const result = await sharedUpload(product.image, {
          skipValidation: true,
          vendorMedia: {
            vendorType: "retailer_wholesaler",
            vendorId: product.retailerWholesaler || vendorId,
            assetPurpose: "product_cover",
            entityType: "retailerWholesalerProduct",
            entityId: product._id || product.name || "new-product",
            source: "dashboard",
          },
          onProgress: (percent) => {
            if (!isMounted.current) return;
            setUploadProgress(percent);
          },
        });

        imageUrl = result.secure_url;
      }

      /* Resolve newly-picked extra angles. Two formats may flow in:
           - dataURL strings (just picked via the strip's file input), or
           - already-stored https URLs (rare on Create — just defensive).
         Blob entries aren't expected here because the strip always reads
         picks via FileReader, so we only need to handle dataURL strings. */
      let resolvedAdditional = [];
      const picked = Array.isArray(product.additionalImages)
        ? product.additionalImages
        : [];
      for (const entry of picked) {
        if (typeof entry !== "string" || !entry) continue;
        if (entry.startsWith("data:")) {
          // eslint-disable-next-line no-await-in-loop
          const r = await sharedUpload(entry, {
            skipValidation: true,
            vendorMedia: {
              vendorType: "retailer_wholesaler",
              vendorId: product.retailerWholesaler || vendorId,
              assetPurpose: "product_angle",
              entityType: "retailerWholesalerProduct",
              entityId: product._id || product.name || "new-product",
              source: "dashboard",
            },
          });
          if (!r?.secure_url) {
            if (isMounted.current) {
              toast.error("One of the extra angles failed to upload.");
              setSubmitting(false);
              setUploading(false);
            }
            return;
          }
          resolvedAdditional.push(r.secure_url);
        } else {
          resolvedAdditional.push(entry);
        }
      }

      // Now create the product with the Cloudinary URL
      const retailerWholesalerProductData = {
        name: product.name,
        /* WYSIWYG pipeline: `product.description` state holds Quill HTML.
           Send it as `descriptionHtml` (server sanitizes + derives plain
           text) plus a client-derived plain `description` so older backend
           versions degrade gracefully. */
        description: quillHtmlToPlainText(product.description),
        descriptionHtml: product.description,
        sectionId: product.section,
        retailerWholesalerId: product.retailerWholesaler,
        price: product.price,
        image: imageUrl,
        additionalImages: resolvedAdditional,
        /* Contract-shaped entries; ProductVideoSection uploads on pick, so
           these are ready to persist as-is. */
        videos: Array.isArray(product.videos) ? product.videos : [],
        countInStock: product.countInStock,
        enabled: product.enabled,
        requiredPaymentMethod: product.requiredPaymentMethod,
        discount: discountPayloadOf(product.discount),
        codDisabled: product.requiredPaymentMethod !== "NONE",
        optionGroups: selectedOptionGroups.map((group) => group.value),
        unit_id: selectedUnit?.value,
        measurements: product.measurements,
        category: selectedCategory,
        // Minimum order volume is enforced by the server at upload (explicit
        // for wholesalers); send what the vendor chose instead of relying on
        // a read-time default.
        minimumOrderVolume:
          operationMode === "WHOLESALER" ? minimumOrderVolume : 1,
        fulfillment: serialiseProductFulfillment(product.fulfillment),
      };

      await dispatch(
        createRetailerWholesalerProduct(
          retailerWholesalerProductData,
          vendorId
        )
      );

      if (isMounted.current) {
        // Reset form and redirect
        setProduct({
          name: "",
          description: "",
          section: "",
          retailerWholesaler: "",
          price: 0.0,
          countInStock: 0,
          image: null,
          additionalImages: [],
          videos: [],
          enabled: false,
          codDisabled: false,
          requiredPaymentMethod: "NONE",
          discount: null,
          optionGroups: [],
          measurements: 1,
        });
        setSelectedOptionGroups([]);
        setSelectedUnit([]);
        setMinimumOrderVolume(10);
        setShowConfirmModal(false);
        history.push("/admin/catalog");
      }
    } catch (error) {
      if (isMounted.current) {
        toast.error("Failed to save product: " + error.message);
      }
    } finally {
      if (isMounted.current) {
        setUploading(false);
        setSubmitting(false);
      }
    }
  };

  const handleDiscardChanges = () => {
    setProduct({
      name: "",
      description: "",
      section: "",
      retailerWholesaler: "",
      price: 0.0,
      countInStock: 0,
      image: null,
      additionalImages: [],
      videos: [],
      enabled: false,
      codDisabled: false,
      requiredPaymentMethod: "NONE",
      discount: null,
    });
    setShowConfirmModal(false);
    history.push("/admin/catalog");
  };

  const handleCloseDiscardModal = () => {
    setShowConfirmModal(false);
  };

  const handleOptionGroupSave = (newOptionGroup) => {
    if (newOptionGroup && newOptionGroup._id) {
      setSelectedOptionGroups((prevGroups) => [
        ...prevGroups,
        {
          value: newOptionGroup._id,
          label: `${newOptionGroup.name} (Min: ${newOptionGroup.minOptions}, Max: ${newOptionGroup.maxOptions})`,
        },
      ]);
    } else {
      console.error("Invalid option group data:", newOptionGroup);
    }
  };

  // handle Unit Selection
  const handleUnitChange = (value) => {
    setSelectedUnit(value);
  };

  // handle selection
  const handleCategoryInputChange = (value) => {
    setValue(value);
  };

  // handle category Selection
  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  const handleAspectChange = (newAspect) => {
    setAspect(newAspect);

    if (imgRef.current) {
      const { width, height } = imgRef.current;

      // Calculate new crop based on aspect ratio
      let newCrop;
      if (newAspect) {
        // For fixed aspect ratios (square or landscape)
        const smallerDimension = Math.min(width, height);
        const cropWidth =
          newAspect >= 1 ? smallerDimension * newAspect : smallerDimension;
        const cropHeight =
          newAspect >= 1 ? smallerDimension : smallerDimension / newAspect;

        newCrop = centerAspectCrop(width, height, newAspect);
      } else {
        // For free crop
        newCrop = {
          unit: "%",
          x: 10,
          y: 10,
          width: 80,
          height: 80,
        };
      }

      setCrop(newCrop);
      setCompletedCrop(newCrop);
    }
  };

  const isCropValid = useCallback(() => {
    if (!completedCrop?.width || !completedCrop?.height) return false;

    const pixelWidth = imgRef.current
      ? completedCrop.width * (imgRef.current.naturalWidth / 100)
      : 0;
    const pixelHeight = imgRef.current
      ? completedCrop.height * (imgRef.current.naturalHeight / 100)
      : 0;

    // For fixed aspect ratios, check minimum dimensions
    if (aspect) {
      return pixelWidth >= MIN_DIMENSION && pixelHeight >= MIN_DIMENSION;
    }

    // For free crop, ensure reasonable minimum size (e.g., 100px)
    const MIN_FREE_CROP = 100;
    return pixelWidth >= MIN_FREE_CROP && pixelHeight >= MIN_FREE_CROP;
  }, [completedCrop, aspect]);

  // Step numbers are handed out during render instead of hardcoded. "Minimum
  // Order Volume" only renders for wholesalers, so fixed labels made retailers
  // read 6 → 8 with no field 7 in sight. `step()` is called in JSX source order
  // and `&&`-guarded blocks short-circuit before reaching it.
  // Reset on every render — this must not be hoisted out of the component.
  let stepNo = 0;
  const step = (text) => `${(stepNo += 1)}. ${text}`;

  return (
    <>
      <style>{adornedStyles}</style>
      <Container className="vendor-product-form">
        <Row className="justify-content-md-center">
          <Col md={12}>
            <Card className="create-product-card-adorned">
              <div className="create-product-header-adorned">
                <h3 style={{ margin: 0, fontSize: '28px', fontWeight: 700 }}>Create Product</h3>
                <p style={{ margin: '8px 0 0 0', opacity: 0.9, fontSize: '14px' }}>Add a new product to your catalog</p>
              </div>
              <Card.Body className="create-product-body-adorned">
                <Form onSubmit={handleSubmit}>
                  <HeadOfficeProductNote gate={gate} />
                {/* Vendor team permissions. Creating a product is catalogue:edit. */}
                {!gate.canCatalogue && (
                  <Alert variant="warning" className="mb-3">
                    Your role does not allow creating products. The form is read-only.
                  </Alert>
                )}

                  {/* Shared with the Edit form — see
                      components/ProductImageSection.js. `product.image` here can
                      be a File (pre-upload) rather than a URL, so hand the
                      section the preview string instead of the raw value. */}
                  <ProductImageSection
                    label={step("Product image")}
                    image={
                      typeof product.image === "string"
                        ? product.image
                        : product.image
                        ? imagePreview
                        : null
                    }
                    onFileSelected={handleImageFile}
                    onRemoveImage={() => {
                      setProduct((prev) => ({ ...prev, image: null }));
                      setImagePreview(null);
                      setUploadError(null);
                    }}
                    onEditImage={
                      product.image
                        ? () => {
                            setImagePreview(
                              typeof product.image === "string"
                                ? product.image
                                : URL.createObjectURL(product.image)
                            );
                            setShowPreviewModal(true);
                          }
                        : undefined
                    }
                    uploadError={uploadError}
                    additionalImages={product.additionalImages || []}
                    onAdditionalImagesChange={(next) =>
                      setProduct((prev) => ({
                        ...prev,
                        additionalImages: next,
                      }))
                    }
                    vendorId={vendorId}
                    onShootImageSelected={(imageUrl) => {
                      setProduct((prev) => ({ ...prev, image: imageUrl }));
                      setImagePreview(imageUrl);
                      setUploadError(null);
                    }}
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  />

                  <ProductVideoSection
                    videos={product.videos || []}
                    onChange={(next) =>
                      setProduct((prev) => ({ ...prev, videos: next }))
                    }
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  />

                  <Form.Group>
                    <Form.Label>{step("Name")}</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={product.name}
                      onChange={handleInputChange}
                      required
                      maxLength={40}
                      placeholder="Product name..."
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    />
                    <Form.Text
                      className={
                        (product.name || "").length >= 40
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      {(product.name || "").length}/40 characters
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mt-3">
                    <Form.Label>{step("Description (optional)")}</Form.Label>
                    {/* Standardized WYSIWYG editor (shared toolbar config):
                        what the vendor formats here is exactly what renders
                        on the storefront. HTML is sanitized server-side and
                        a plain-text copy is derived for the mobile apps. The
                        injected typography CSS makes the editor content render
                        with the SAME font/size/spacing as the storefront. */}
                    <style>{DESCRIPTION_TYPOGRAPHY_CSS}</style>
                    <ReactQuill
                      theme="snow"
                      className={DESCRIPTION_EDITOR_CLASS}
                      value={product.description}
                      onChange={(html) =>
                        setProduct((prev) => ({ ...prev, description: html }))
                      }
                      modules={DESCRIPTION_QUILL_MODULES}
                      formats={DESCRIPTION_QUILL_FORMATS}
                      placeholder="Describe the product — key features, specs, what makes it great…"
                      readOnly={submitting}
                      style={{ backgroundColor: "#fff" }}
                    />
                    <Form.Text className="text-muted">
                      Use headings, bold and bullet lists — customers see this
                      formatting exactly as shown here.
                    </Form.Text>
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      {/* mt-3 to match its row partner — the two columns must
                          share a baseline now that they sit side by side. */}
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Retailer / wholesaler")}</Form.Label>
                        <AppSelect block
                          name="retailerWholesaler"
                          value={product.retailerWholesaler}
                          onChange={handleInputChange}
                          required
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        >
                          <option>Choose...</option>
                          {retailersWholesalers.map((rw) => (
                            <option key={rw._id} value={rw.owner}>
                              {rw.name}
                            </option>
                          ))}
                        </AppSelect>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Choose section")}</Form.Label>
                        <AppSelect block
                          name="section"
                          value={product.section}
                          onChange={handleInputChange}
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        >
                          <option>Choose...</option>
                          {sections.map((section) => (
                            <option key={section._id} value={section._id}>
                              {section.title}
                            </option>
                          ))}
                        </AppSelect>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Short numeric inputs pair off into rows rather than each claiming a full-width line — the main reason this form scrolled so far. */}
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Price")}</Form.Label>
                        <Form.Control
                          type="number"
                          name="price"
                          value={product.price}
                          onChange={handleInputChange}
                          required
                          disabled={gate.lockPricing} title={gate.pricingTitle}
                        />
                        {priceWarning && (
                          <Alert variant="danger">
                            <MdWarning size={24} className="me-2" />
                            {priceWarning}
                          </Alert>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      {operationMode === "WHOLESALER" && (
                        <Form.Group controlId="minimumOrderVolume" className="mt-3">
                          <Form.Label>{step("Minimum order volume (units)")}</Form.Label>
                          <AppSelect block disabled={gate.lockPricing} title={gate.pricingTitle}
                            value={minimumOrderVolume}
                            onChange={(e) =>
                              setMinimumOrderVolume(parseInt(e.target.value))
                            }
                          >
                            {[10, 20, 30, 50, 100, 150, 200, 300, 500].map(
                              (volume) => (
                                <option key={volume} value={volume}>
                                  {volume}
                                </option>
                              )
                            )}
                          </AppSelect>
                          {/* Foot note ~ Default iss 10 Units */}
                          <Form.Text className="text-muted mb-3">
                            <strong
                              style={{
                                color: "lightblue",
                                fontSize: "10px",
                                fontStyle: "italic",
                              }}
                            >
                              Minimum Order Volume Default: {minimumOrderVolume} Units
                            </strong>
                          </Form.Text>
                        </Form.Group>
                      )}
                      <ProductFreightFields
                        product={product}
                        setProduct={setProduct}
                        disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      />
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Count in stock")}</Form.Label>
                        <Form.Control
                          type="number"
                          name="countInStock"
                          value={product.countInStock}
                          onChange={handleInputChange}
                          required
                          min="1"
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      {/* Measurements */}
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Measurement")}</Form.Label>
                        <Form.Control
                          name="measurements"
                          type="number"
                          inputMode="numeric"
                          pattern="^\d*(\.\d{0,2})?$"
                          value={product.measurements}
                          onChange={handleInputChange}
                          required
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      {/* Units Dropdown*/}
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Unit")}</Form.Label>
                        <Select
                          options={unitSelectOptions(siUnits, selectedUnit?.value)}
                          value={selectedUnit?.value ? selectedUnit : null}
                          onChange={handleUnitChange}
                          isClearable={true}
                          isSearchable={true}
                          placeholder="Select Measurement Units..."
                          isDisabled={gate.lockCatalogue}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      {/* Category */}
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Category association (optional)")}</Form.Label>
                        <AsyncSelect
                          cacheOptions
                          defaultOptions
                          value={selectedCategory}
                          getOptionLabel={(e) => e.category}
                          getOptionValue={(e) => e._id}
                          loadOptions={loadCategory}
                          onInputChange={handleCategoryInputChange}
                          onChange={handleCategoryChange}
                          isClearable={true}
                          isMulti={true}
                          isDisabled={gate.lockCatalogue}
                        />
                        <CategorySuggestions
                          name={product.name}
                          unitId={selectedUnit?.value || null}
                          vendorId={product.retailerWholesaler}
                          categories={allCategories}
                          selected={selectedCategory}
                          disabled={gate.lockCatalogue}
                          onAdd={(category) =>
                            setSelectedCategory((prev) => [...(prev || []), category])
                          }
                          onApplyUnit={
                            gate.lockCatalogue
                              ? undefined
                              : ({ _id, unit, measurements }) => {
                                  setSelectedUnit({ value: _id, label: unit, name: unit });
                                  setProduct((prev) => ({ ...prev, measurements }));
                                }
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mt-3">
                        <Form.Label>{step("Option groups")}</Form.Label>
                        <Select
                          isMulti
                          options={optionGroups.map((optionGroup) => ({
                            value: optionGroup._id,
                            label: `${optionGroup.name} (Min: ${optionGroup.minOptions}, Max: ${optionGroup.maxOptions})`,
                          }))}
                          value={selectedOptionGroups}
                          onChange={setSelectedOptionGroups}
                          placeholder="Select option groups..."
                          isDisabled={gate.lockCatalogue}
                        />
                        <Button
                          variant="link"
                          onClick={() => setShowOptionGroupModal(true)}
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        >
                          Create New Option Group
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className={classes.label}>Customer payment requirement</Form.Label>
                    <AppSelect block
                      name="requiredPaymentMethod"
                      value={product.requiredPaymentMethod}
                      onChange={(e) =>
                        setProduct({
                          ...product,
                          requiredPaymentMethod: e.target.value,
                          codDisabled: e.target.value !== "NONE",
                        })
                      }
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    >
                      <option value="NONE">Any method (Cash on Delivery allowed)</option>
                      <option value="ANY_ONLINE">Require payment before acceptance (any online method)</option>
                      <option value="MOMO">MTN Mobile Money only</option>
                      <option value="AIRTEL">Airtel Money only</option>
                      <option value="VISA">Card only</option>
                      <option value="ZAMTEL">Zamtel Kwacha only</option>
                    </AppSelect>
                    <Form.Text className="text-muted">
                      When prepayment is required, you cannot accept or prepare the order until Lusuku confirms payment.
                    </Form.Text>
                  </Form.Group>
                  {/* Vendor discount: the list price above stays; the sale price is derived on read. */}
                  <DiscountFields
                    disabled={gate.lockPricing}
                    title={gate.pricingTitle}
                    value={product.discount}
                    onChange={(next) => setProduct((prev) => ({ ...prev, discount: next }))}
                    listPrice={product.price}
                  />

                  <Form.Group>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={product.enabled}
                          onChange={(e) =>
                            setProduct({
                              ...product,
                              enabled: e.target.checked,
                            })
                          }
                          name="enabled"
                          color="secondary"
                          disabled={gate.lockActivation} title={gate.activationTitle}
                        />
                      }
                      label={
                        product.enabled
                          ? "Activate Product For Customers"
                          : "Deactivate Product For Customers"
                      }
                      classes={{ label: classes.label }}
                    />
                    <Form.Text className="text-muted">
                      New products start deactivated so they can be checked before customers see them. Turn this on only if this one has already been checked.
                    </Form.Text>
                  </Form.Group>

                  <Button
                    variant="danger"
                    onClick={() => setShowConfirmModal(true)}
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    style={{
                      color: submitting ? "black" : "white",
                    }}
                  >
                    Discard changes?
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    style={{
                      color: submitting ? "black" : "white",
                      backgroundColor: submitting ? "#e9ecef" : "#007BFF",
                      marginLeft: "10px",
                    }}
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  >
                    {uploading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Saving...
                      </>
                    ) : (
                      "Save changes"
                    )}
                  </Button>
                </Form>
                {uploading && (
                  <UploadProgress percent={uploadProgress} label="Uploading image" />
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Image preview Modal */}
      <Modal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center justify-content-between w-100">
            <span>Crop and Preview Image</span>
            <div className="d-flex gap-2">
              <Tooltip title="Free Crop">
                <IconButton
                  size="small"
                  onClick={() => handleAspectChange(undefined)}
                  style={{
                    backgroundColor: !aspect
                      ? "rgba(25, 118, 210, 0.12)"
                      : "transparent",
                    color: !aspect ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <MdCrop size={20} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Square (1:1)">
                <IconButton
                  size="small"
                  onClick={() => handleAspectChange(1)}
                  style={{
                    backgroundColor:
                      aspect === 1
                        ? "rgba(25, 118, 210, 0.12)"
                        : "transparent",
                    color: aspect === 1 ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <MdCropSquare size={20} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Landscape (16:9)">
                <IconButton
                  size="small"
                  onClick={() => handleAspectChange(16 / 9)}
                  style={{
                    backgroundColor:
                      aspect === 16 / 9
                        ? "rgba(25, 118, 210, 0.12)"
                        : "transparent",
                    color:
                      aspect === 16 / 9 ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                  }}
                >
                  <MdCropLandscape size={20} />
                </IconButton>
              </Tooltip>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            <div
              className="flex-grow-1"
              style={{
                maxHeight: "70vh",
                overflow: "auto",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                padding: "16px",
              }}
            >
              {imagePreview && (
                <ReactCrop
                  crop={crop}
                  onChange={(_, percentCrop) => {
                    setCrop(percentCrop);
                  }}
                  onComplete={(c) => {
                    setCompletedCrop(c);
                  }}
                  aspect={aspect}
                  minWidth={aspect ? MIN_DIMENSION : undefined}
                  minHeight={aspect ? MIN_DIMENSION : undefined}
                >
                  <img
                    ref={imgRef}
                    alt="Crop me"
                    src={imagePreview}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "70vh",
                      objectFit: "contain",
                    }}
                    onLoad={handleImageLoad}
                  />
                </ReactCrop>
              )}
            </div>
            <div
              className="ms-3"
              style={{
                width: "280px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <h6>Preview</h6>
              <div
                style={{
                  width: "100%",
                  aspectRatio: "1",
                  overflow: "hidden",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                }}
              >
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div className="mt-2">
                <Form.Text className="text-muted">
                  <strong>Image Requirements:</strong>
                  <ul style={{ fontSize: "12px", marginTop: "8px" }}>
                    <li>
                      Format: JPG or PNG
                      {isFormatCorrect ? (
                        <span className="text-success"> ✔</span>
                      ) : (
                        <span className="text-danger"> ✘</span>
                      )}
                    </li>
                    <li>
                      Size: ≤ 10MB
                      {isSizeCorrect ? (
                        <span className="text-success"> ✔</span>
                      ) : (
                        <span className="text-danger"> ✘</span>
                      )}
                    </li>
                    <li>
                      Dimensions: ≥ 1000x1000px
                      {completedCrop &&
                        completedCrop.width >= MIN_DIMENSION &&
                        completedCrop.height >= MIN_DIMENSION ? (
                        <span className="text-success"> ✔</span>
                      ) : (
                        <span className="text-danger"> ✘</span>
                      )}
                    </li>
                  </ul>
                </Form.Text>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowPreviewModal(false);
              setCrop({
                unit: "%",
                x: 0,
                y: 0,
                width: 90,
                height: 90,
              });
              setCompletedCrop(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveCrop}
            disabled={!isCropValid()}
          >
            Save Cropped Image
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for confirmation of product creation cancelation */}
      <Modal show={showConfirmModal} onHide={handleCloseDiscardModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "1.5rem",
              }}
            >
              <MdWarning
                size="30px"
                color="orange"
                style={{ marginRight: "10px" }}
              />
              You might have unsaved changes!
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>If you leave this page you will lose the changes you made.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseDiscardModal}
            disabled={submitting}
          >
            Go back
          </Button>
          <Button
            variant="danger"
            onClick={handleDiscardChanges}
            disabled={submitting}
          >
            Discard changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for creating a new option group */}
      {/* <OptionGroupForm
                show={showOptionGroupModal}
                handleClose={() => setShowOptionGroupModal(false)}
                handleSave={handleOptionGroupSave}
            /> */}
      <RetailerWholesalerOptionGroupForm
        show={showOptionGroupModal}
        handleClose={() => setShowOptionGroupModal(false)}
        handleSave={handleOptionGroupSave}
      />

      {/* Add some CSS for the active state of crop buttons */}
      <style>
        {`
          button.btn-outline-success {
            border-color: #28a745;
            color: #28a745;
          }
          
          button.btn-outline-success:hover {
            background-color: rgba(40, 167, 69, 0.08);
            border-color: #28a745;
            color: #28a745;
            transform: translateY(-1px);
          }
          
          button.btn-outline-danger {
            border-color: #dc3545;
            color: #dc3545;
          }
          
          button.btn-outline-danger:hover {
            background-color: rgba(220, 53, 69, 0.08);
            border-color: #dc3545;
            color: #dc3545;
            transform: translateY(-1px);
          }

          .MuiIconButton-root {
            transition: all 0.2s ease-in-out;
          }
          
          .MuiIconButton-root:hover {
            transform: scale(1.1);
          }

          .image-action-button {
            border-radius: 20px;
            padding: 6px 16px;
            font-size: 0.875rem;
            text-transform: none;
            font-weight: 500;
            transition: all 0.2s ease-in-out;
            display: flex;
            align-items: center;
          }

          .image-action-button:hover {
            transform: translateY(-1px);
          }
          
          button.btn-outline-success.image-action-button {
            border-color: #28a745;
            color: #28a745;
          }
          
          button.btn-outline-success.image-action-button:hover {
            background-color: rgba(40, 167, 69, 0.08);
            border-color: #28a745;
            color: #28a745;
          }
          
          button.btn-outline-danger.image-action-button {
            border-color: #dc3545;
            color: #dc3545;
          }
          
          button.btn-outline-danger.image-action-button:hover {
            background-color: rgba(220, 53, 69, 0.08);
            border-color: #dc3545;
            color: #dc3545;
          }
        `}
      </style>
    </>
  );
};

export default CreateRetailerWholesalerProductForm;
